export enum PolicyType {
  softwareDisabled = 2,
  processControl = 3,
  screenWatermark = 4,
  internet = 6,
  usbControl = 7,
  ransomWareProtect = 8,
  dlp_control_type = 9,
  file_whitelist_type = 11,
  system_config = 13,
  asset_registration = 12,
  system_cascade_update = 14,
  ip_address_blocking = 15,
  terminal_flow_monitor = 16,
   remote_login_auth = 17
}

export enum PolicySettingType {
  softwareDisabled = '23',
  processControl = '24',
  screenWatermark = '25',
  internet = '4',
  usbControl = '7',
  ransomWareProtect = '27',
  dlp_control_type_setting_type = '29',
  file_whitelist = '31',
  system_config = '33',
  asset_registration = '32',
  system_cascade_update = '34',
  ip_address_blocking = '35',
  terminal_flow_monitor = '3',
  remote_login_auth = '36',
}
